import { useEffect, useState, useRef } from 'react';
import { withFormik } from 'formik';
import classNames from 'classnames';
import { Button, Row, Col, Form } from 'react-bootstrap';
import { format, parse, add, startOfDay } from 'date-fns';
import { withStore } from 'store';
import { ShareLink, PrintQR } from 'components/Cards';
import { updateGiftTable } from 'store/actions/giftTable';
import { UploadImageModal } from 'components/gifts-table';
import uploadIcon from 'assets/img/upload-icon.svg';
import iconEdit from 'assets/img/icon_edit.svg';
import { fetchEventTypes } from 'store/actions/catalogs';
import { FLAT } from 'constants/transformers';
import styles from './styles.module.scss';
import { getTableDate } from './utils';
import TableWelcomeMessage from 'components/gifts-table/TableWelcomeMessage';

const TableHero = ({
  custom = false,
  typeId,
  onSave,
  readOnly = false,
  onDeleteHero,
  values,
  setFieldValue,
  showTableInfoData = false,
  tableInfo = {},
  eventIcon = '',
  dispatch,
  eventTypes,
  ...props
}) => {
  const {
    image,
    eventName,
    name,
    date: tableInfoDate,
  } = showTableInfoData ? tableInfo : props;

  const [icon, setIcon] = useState(eventIcon);
  const [editTitle, setEditTitle] = useState(false);
  const [editDate, setEditDate] = useState(false);
  const [tableName, setTableName] = useState(name);
  const [tableDate, setTableDate] = useState(tableInfoDate);
  const [showUploadImage, setShowUploadImage] = useState(false);
  const [minDate, setMinDate] = useState(new Date());
  const [errorDate, setErrorDate] = useState(false);

  const date = getTableDate(tableDate);
  const titleRef = useRef(null);
  const dateRef = useRef({});

  const saveTitle = (element) => {
    if (element.target.value) {
      const payload = { gift_table: { name: element.target.value } };
      dispatch(updateGiftTable(payload));
      setTableName(element.target.value);
    }

    setEditTitle(false);
  };

  const saveDate = (element) => {
    if (element.target.value) {
      const newDate = parse(element.target.value, 'yyyy-MM-dd', new Date());
      const eventDate = format(newDate, 'yyyyMMdd');
      if (newDate >= minDate) {
        setErrorDate(false);
        const payload = { event_date: eventDate };
        dispatch(updateGiftTable(payload));
        setTableDate(format(newDate, 'yyyy-MM-dd 00:00:00'));
        setEditDate(false);
      } else {
        setErrorDate(true);
      }
    }
  };

  const handleClickUploadImage = () => {
    setShowUploadImage(true);
  };

  const handleCloseUploadImage = () => {
    setShowUploadImage(false);
  };

  useEffect(() => {
    if (eventTypes) {
      const eventTypeInfo = eventTypes.find(
        (eventType) => eventType.id === typeId
      );
      setIcon((currentIcon) =>
        eventTypeInfo ? eventTypeInfo.image : currentIcon
      );
      setMinDate((currentDays) =>
        eventTypeInfo
          ? startOfDay(
              add(new Date(), {
                days: 1 + parseInt(eventTypeInfo.restriction_days, 10),
              })
            )
          : currentDays
      );
    }
  }, [eventTypes, typeId]);

  useEffect(() => {
    dispatch(fetchEventTypes(false, true, FLAT));
  }, []);

  useEffect(() => {
    if (editTitle) {
      titleRef.current.focus();
    }
  }, [editTitle]);

  useEffect(() => {
    if (name) {
      setTableName(name);
    }
  }, [name]);

  useEffect(() => {
    if (tableInfoDate) {
      let tmpDate = tableInfoDate;
      if (tableInfoDate.length === 8) {
        tmpDate = `${tmpDate.substring(0, 4)}-${tmpDate.substring(
          4,
          6
        )}-${tmpDate.substring(6, 8)} 00:00:00`;
      }
      setTableDate(tmpDate);
    }
  }, [tableInfoDate]);

  const saveField = (values) => {
    dispatch(updateGiftTable(values));
  };

  localStorage.setItem('icon', icon);
  //console.log('icon: ',icon);
  return (
    <>
      <UploadImageModal
        show={showUploadImage}
        onClose={handleCloseUploadImage}
        loader={false}
      />
      <div
        className={`${styles.TableHero} px-2 px-sm-3 mb-5 mb-md-4`}
        style={{
          backgroundImage: `url(${image})`,
        }}
      >
        <div className={styles.TableHero_transparency} />
        {/* seccion botones subir foto,QR y compartir */}
        <Row className="d-none d-md-flex">
          <Col
              sm={6}
              className="d-flex justify-content-center justify-content-sm-start mb-3 mb-sm-0"
          >
            {!readOnly && (
                <div className={`${styles.uploadPhoto} px-3`}>
                  <Button onClick={handleClickUploadImage} variant="secondary">
                    Subir foto  <img src={uploadIcon} alt="Subir foto1" className="mr-2" />
                  </Button>
                </div>
            )}
          </Col>
          <Col
              sm={6}
              className="d-flex align-items-end justify-content-end"
          >
            {!readOnly && (
                <div className={styles.shareGiftTable}>
                  <PrintQR variant="minimalist" />

                  <div className={styles.spacediv} />

                  <ShareLink
                      variant="minimalist"
                      url="http://sears.com.mx/mesaderegalos/123456789/anabel-y-enrique"
                  />
                </div>
            )}
          </Col>
        </Row>
        {/* fin seccion botones subir foto,QR y compartir */}
        {/* seccion botones subir foto,QR y compartir mobile */}
        <div
          className={`${styles.TableHero__ActionIcons} justify-content-between justify-content-md-end`}
        >
          {!readOnly && (
            <div
              className={`${styles.uploadPhotoIcon} d-md-none`}
              onClick={handleClickUploadImage}
              onKeyDown={handleClickUploadImage}
              role="button"
              tabIndex="0"
            >
              <img src={uploadIcon} alt="Subir foto2" />
            </div>
          )}
        </div>
        <div className={styles.TableHero_controls}>
        {!readOnly && (
            <div className={`${styles.shareGiftTableMini} d-md-none`}>
              <PrintQR variant="extraSmall" />

              <ShareLink
                  variant="extraSmall"
                  url="http://sears.com.mx/mesaderegalos/123456789/anabel-y-enrique"
              />
            </div>
        )}
        </div>
        {/* fin seccion botones subir foto,QR y compartir mobile */}
       
        <div className={ !custom ? styles.iconevento : styles.iconeventoCustom  }>
          <div
              className={classNames(
                  styles.TableHero_icon
              )}
          >
            {icon && <img src={icon} alt={eventName} />}
          </div>
        </div>
      </div>
      {readOnly && (
      <Row className={styles.divnew1}>
        <Col className="text-center">
              <h1>
                {tableName}
              </h1>
        </Col>
      </Row>
      )}
      {readOnly && (
      <Row className={styles.divnew2}>
        <Col className="text-center">
          <h6> {date} </h6>
        </Col>
      </Row>
      )}

      {/*readOnly && (
          <Row className={styles.divnew3}>
            <Col className="text-center">
              {/*         COMPONENTE DE BIENVENIDO             }
              <TableWelcomeMessage
                  onSave={saveField}
                  value={tableInfo?.welcome_message}
                  onlyView={true}
              />
            </Col>
          </Row>
      )*/}


      {!readOnly && (
      <Row className={styles.divnew}>
        <Col className="text-center">
        {/* <p className="d-none d-lg-block">{eventName}</p>*/}
        {!editTitle && (
            <h1>
              {tableName}
              {!readOnly && (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                      className={styles.edit}
                      onClick={() => setEditTitle(!editTitle)}
                  >  <i className="fa fa-pencil fa-1x"></i>
                  </a>
              )}
            </h1>
        )}
        {editTitle && (
            <textarea
                type="text"
                id="name"
                className={`title ${styles.editText}`}
                onBlur={saveTitle}
                defaultValue={tableName}
                ref={titleRef}
            />
        )}
        </Col>
        </Row>
      )}
      {!readOnly && (
        <Row className={styles['date-container']}>
          <Col className="text-center">
        {!editDate && (
            <h3 className={styles.date}>
              {date}

              {!readOnly && false && (
                  <button
                      className={styles.edit}
                      type="button"
                      onClick={() => setEditDate(!editDate)}
                  >
                    <img src={iconEdit} alt="Editar fecha de evento" />
                  </button>
              )}
            </h3>
        )}
        {editDate && (
            <>
              <input
                  type="date"
                  id="event_date"
                  className={styles.TableHero_dateEdit}
                  onBlur={saveDate}
                  required
                  defaultValue={tableDate.substring(0, 10)}
                  placeholder={tableDate.substring(0, 10)}
                  ref={dateRef}
                  min={format(minDate, 'yyyy-MM-dd')}
              />
              {errorDate && (
                  <Form.Control.Feedback
                      style={{ display: 'block' }}
                      className="col-12"
                      type="invalid"
                  >
                    Selecciona una fecha válida
                  </Form.Control.Feedback>
              )}
            </>
        )}
        </Col>
      </Row>
      )}
      {!readOnly && (
      <Row className={styles['text-container']}>
        <Col className="text-center">
          {/*         COMPONENTE DE BIENVENIDO             */}
          <TableWelcomeMessage
            onSave={saveField}
            value={tableInfo?.welcome_message}
            onlyView={false}
          />
        </Col>
      </Row>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  tableInfo: state.giftTable.giftTableInfo.data,
  eventTypes: state.catalogs.flatEventTypes || [],
});

export default withStore({ mapStateToProps })(
  withFormik({ mapPropsToValues: () => ({}) })(TableHero)
);
